import type { ReactNode } from "react";
import {
  RiAlertLine,
  RiCheckboxCircleLine,
  RiErrorWarningLine,
  RiInformationLine,
} from "react-icons/ri";

import { cn } from "~/utils/classnames";

const getAlertStyle = (type?: "success" | "error" | "warning" | "info") => {
  switch (type) {
    case "success":
      return "bg-success-200 bg-opacity-20 border border-success-500 text-success-700";
    case "warning":
      return "bg-warning-200 bg-opacity-20 border border-warning-500 text-warning-700";
    case "error":
      return "bg-danger-200 bg-opacity-20 border border-error-500 text-danger-700";
    case "info":
      return "bg-info-200 bg-opacity-20 border border-info-500 text-info-700";
    default:
      return "bg-grey-200";
  }
};

const getIcon = (type?: "success" | "error" | "warning" | "info") => {
  switch (type) {
    case "success":
      return RiCheckboxCircleLine;
    case "warning":
      return RiAlertLine;
    case "error":
      return RiErrorWarningLine;
    case "info":
      return RiInformationLine;
    default:
      return null;
  }
};

export const Alert = ({
  title,
  message,
  type,
  className = "",
}: {
  title?: string;
  message: ReactNode;
  type?: "success" | "error" | "warning" | "info";
  className?: string;
}) => {
  const IconComponent = getIcon(type);
  return (
    <div
      className={cn("flex items-center gap-4 rounded-xl px-6 py-4", getAlertStyle(type), className)}
    >
      {IconComponent ? <IconComponent className="h-6 w-6 shrink-0 grow-0 basis-6" /> : null}
      <div>
        {title ? <div>{title}</div> : null}
        <div>{message}</div>
      </div>
    </div>
  );
};
